export const calculatePriceByType = (price, type, pct = 1) => {
  let amount = 0;
  switch (type) {
    case "msrp":
      amount = parseInt(price / (1 - pct * 0.01));
      break;
    case "map":
      amount = parseInt(price / 0.80);
      break;
    case "salesPrice":
      const salePriceMarkup = pct === 1 ? 0.999 : pct;
      amount = parseInt(price / (1 - salePriceMarkup));
      break;
    case "markdown":
      //assuming pct is in decimal form 
      amount = parseInt(price - (pct * price));
      break;
    
    default:
      amount = price;
  }
  return amount;
};

export const enumOrderType = {
  ANC: "Accepted No Changes",
  CS: "Consumer Sold",
  DO: "Order",
  Invc: "Invoiced",
  Quote: "Quote",
  Sched: "Scheduled",
  Leads: "Leads"
};

export const enumWarrantyType = [
  { key: "consumer", value: "5 Year Limited + 10 Year Limited Hull Consumer Warranty" },
  { key: "consumerlimited", value: "10 Year Limited Hull Consumer Warranty" },
  { key: "rental", value: "Rental (No Warranty)" },
  { key: "club", value: "1 Year Club Warranty" },
  { key: "international", value: "International (10 Year Limited Hull + 1 Year Parts & Labor)"},
];

export const reactNumber = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};